import { Col, Row } from "reactstrap";
import imagenCuellar from "../../../assets/avantSolar/Promociones/promociones-3-torrecuellar.jpg";
import imagenExpo from "../../../assets/avantSolar/Promociones/promociones-3-expo.jpg";
import imagenLeon from "../../../assets/avantSolar/Promociones/promociones-3-leon.jpg";
import imagenFigueres from "../../../assets/avantSolar/Promociones/promociones-3-figueres.jpg";

const Instalaciones = ({ setImagen }) => {
  return (
    <>
      <div>
        <p className="p-0 m-0 h4 text-center text-sm-left font-weight-bold">
          INSTALACIONES
        </p>
        <hr></hr>
        <div className="pl-5 pt-3 pr-5">
          <p>
            Fabricamos y montamos lo que requiera su proyecto. Le asesoraremos y
            ayudaremos a conseguir su objetivo, tanto en instalaciones fijas
            como con seguimiento.
          </p>
          <Row className="mt-5">
            <Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenExpo);
                  }}
                >
                  <p className="textoInstalaciones">
                    CUBIERTA EXPO ZARAGOZA 2008 - 500KW
                  </p>
                  <ul>
                    <li>
                      Fabricación estructura metálica, montaje mecánico y
                      eléctrico
                    </li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenCuellar);
                  }}
                >
                  <p className="textoInstalaciones">
                    TORRECUELLAR ABENGOA - 500KW
                  </p>
                  <ul>
                    <li>
                      Montaje mecánico y eléctrico sobre marquesina aparcamiento
                    </li>
                  </ul>
                </div>
              </Col>
            </Col>
            <Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenFigueres);
                  }}
                >
                  <p className="textoInstalaciones">FIGUERES - 100KW</p>
                  <ul>
                    <li>Montaje 9 seguidores AvantTracker 15 y obra civil </li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenLeon);
                  }}
                >
                  <p className="textoInstalaciones">LEON - 100KW</p>
                  <ul>
                    <li>Montaje 5 seguidores AvantTracker 15</li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenExpo);
                  }}
                >
                  <p className="textoInstalaciones">SALAMANCA - 100KW</p>
                  <ul>
                    <li>Montaje 5 seguidores AvantTracker 15 y obra civil</li>
                  </ul>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Instalaciones;
